<template>
  <section class="wrapper">
    <div class="user-info">
      <span class="photo"><img src="../../assets/img/touPhotn.png" alt=""></span>
      <span class="name">
        <i>{{LoginInfo.NickName}}</i>
        <small>{{LoginInfo.LoginName}}</small>
      </span>
    </div>
    <van-grid :border="false" class="menu">
      <van-grid-item text="帮助中心" icon="question-o"/>
      <van-grid-item text="客服中心" icon="smile-comment-o"/>
      <van-grid-item text="分享好友" icon="point-gift-o"/>
      <van-grid-item text="寻找会计" icon="search"/>
    </van-grid>
    <van-cell-group title="基本资料管理" class="cell-group">
      <van-cell title="修改昵称" icon="manager-o" is-link/>
      <van-cell title="邮箱信息添加" icon="edit" is-link to="/mine/modify-email"/>
      <van-cell title="修改密码" icon="edit" is-link/>
    </van-cell-group>
    <van-cell-group class="mt10 cell-group">
      <van-cell title="修改姓" icon="manager-o" is-link/>
      <van-cell title="修改名" icon="manager-o" is-link/>
      <van-cell title="修改中间名" icon="manager-o" is-link/>
      <van-cell title="关联微信" icon="chat-o" is-link/>
    </van-cell-group>
    <webFooter page="我的"></webFooter>
  </section>
</template>

<script>
  import webFooter from "../layout/components/Footer";

  export default {
    name: "my",
    components: {
      webFooter
    },
    data() {
      return {
        LoginInfo: {
          NickName: '',
          LoginName: ''
        }
      }
    },
    mounted: function () {
      this.getLoginInfo();
    },
    methods: {
      getLoginInfo() {
        let userInfo = this.getCookie("UserInfo");
        let companyInfo = this.getCookie("CompanyInfo");
        if(userInfo!=null){
          this.LoginInfo.NickName=userInfo.NickName||userInfo.FirstName+userInfo.LastName;
          this.LoginInfo.LoginName=userInfo.LoginName||userInfo.TelName;
          if(companyInfo!=null) {
            this.LoginInfo.NickName = companyInfo.rNickName || userInfo.NickName||userInfo.FirstName+userInfo.LastName;
          }
        }
      },
    }
  }
</script>

<style lang="less" scoped>
  .wrapper {
    .user-info {
      width: 100%;
      height: 9.4rem;
      background: url("../../assets/img/bgColor.png");
      background-size: 100% 100%;
      border-radius: 0 0 50% 50%;
      display: flex;
      justify-content: flex-start;
      align-items: center;

      .photo img {
        width: 5rem;
        height: 5rem;
        margin-left: 2.3rem;
      }

      .name {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        margin-left: 1.3rem;
        color: white;
        font-size: 1.5rem;
      }
    }

    .menu {
      margin-top: 1rem;

      ::v-deep.van-icon {
        color: #1fb1c4
      }
      ::v-deep.van-grid-item__text {
        margin-top: 1rem;
        color:black;
      }
    }

    .cell-group{
      ::v-deep.van-cell__left-icon{
        color: #1fb1c4
      }
    }
  }
</style>
